// src/services/fieldOpsZoneApi.js
// --- UPDATE (Field Ops · Zones v1) — NEW FILE ---------------------------------------------
// Client for /api/v1/field-ops/zones-intel (backend routes/fieldOpsZoneRoutes.js).
// Every call sends the signed-in token; errors carry the server message and HTTP status.
// --- END UPDATE ---------------------------------------------------------------------------
import { config } from '../config';
import { getAuthToken } from '../utils/auth';

const BASE = `${config.apiUrl}/field-ops/zones-intel`;

async function call(path, { method = 'GET', body, signal } = {}) {
    const res = await fetch(`${BASE}${path}`, {
        method, signal,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAuthToken() || ''}` },
        body: body === undefined ? undefined : JSON.stringify(body),
    });
    let json = {};
    try { json = await res.json(); } catch (_) { json = {}; }
    if (!res.ok) {
        const err = new Error(json.message || `Request failed (${res.status})`);
        err.status = res.status;
        throw err;
    }
    return json.data !== undefined ? json.data : json;
}

export const fieldOpsZoneApi = {
    overview: ({ refresh = false, signal } = {}) => call(`/overview${refresh ? '?refresh=1' : ''}`, { signal }),
    zone: (id) => call(`/zones/${encodeURIComponent(id)}`),
    locate: (lat, lng) => call(`/locate?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`),
    updateZone: (id, body) => call(`/zones/${encodeURIComponent(id)}`, { method: 'PATCH', body }),
    refresh: () => call('/refresh', { method: 'POST' }),
};

export default fieldOpsZoneApi;
